import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=6dedf7ea&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dedf7ea')) {
      api.createRecord('6dedf7ea', component.options)
    } else {
      api.reload('6dedf7ea', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=6dedf7ea&", function () {
      api.rerender('6dedf7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/ForgotPassword.vue"
export default component.exports